import React from "react";
import { Box, Typography } from "@mui/material";

interface SizingToolFormLayoutProps {
  children: React.ReactNode;
}

export const SizingToolFormLayout: React.FC<SizingToolFormLayoutProps> = ({
  children,
}) => {
  return <Box sx={{ py: 0 }}>{children}</Box>;
};

export const SectionTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography
    sx={{
      fontWeight: 600,
      fontSize: { xs: 15, sm: 16 },
      mt: 1,
      mb: 0.5,
    }}
  >
    {children}
  </Typography>
);

export const SectionDivider: React.FC = () => (
  <Box
    sx={{
      height: "1px",
      background: "#E0E0E0",
      mb: 2,
    }}
  />
);

export default SizingToolFormLayout;
